module.exports = {
    xl: 1920,
    md: 992,
    sm: 720
};
